import React from "react";
import "./Login.css";

const Login = () => {
  return (
    <div className="login-component" style={{ textAlign: "center" }}>
      <img
        src="https://kler.io/wp-content/uploads/2019/06/kler-corp-sm-light.png"
        alt="KLĒR Apps"
        className="login-logo"
      />
      <div className="row">
        <div className="col s12 m6 offset-m3">
          <div className="card grey darken-1">
            <div className="card-content white-text">
              <span className="card-title">Sign In</span>
              <p>Login to your Customer Account.</p>
            </div>
            <div className="card-action">
              <a href="/auth/google" className="waves-effect waves-light btn">
                Google Sign In
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
